__turbopack_context__.v({
  "balance": "ProfileDropDown-module-scss-module__VG1Z9G__balance",
  "flash": "ProfileDropDown-module-scss-module__VG1Z9G__flash",
  "level": "ProfileDropDown-module-scss-module__VG1Z9G__level",
  "logout": "ProfileDropDown-module-scss-module__VG1Z9G__logout",
  "name": "ProfileDropDown-module-scss-module__VG1Z9G__name",
  "negative": "ProfileDropDown-module-scss-module__VG1Z9G__negative",
  "open": "ProfileDropDown-module-scss-module__VG1Z9G__open",
  "positive": "ProfileDropDown-module-scss-module__VG1Z9G__positive",
  "profileDropDown": "ProfileDropDown-module-scss-module__VG1Z9G__profileDropDown",
  "special": "ProfileDropDown-module-scss-module__VG1Z9G__special",
  "url": "ProfileDropDown-module-scss-module__VG1Z9G__url",
  "urls": "ProfileDropDown-module-scss-module__VG1Z9G__urls",
});
